/* eslint-disable no-unused-vars */
import Specialty from '@/models/Specialty'
import { Component } from '@/models/Specialty'
import { logEvent } from '../../firebase/analytics'
import {
  getClinicalLogs,
  getClinicalLogsByUserId,
  getClinicalLogCount,
  insertClinicalLog,
  insertManyClinicalLogs,
  removeClinicalLogs,
  updateClinicalLog,
  getUsersByIds
} from '../../services/mongodb.js'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'

function getAcronym(value) {
  if (typeof value === 'string' && value.length > 0) {
    var matches = value.match(/\b(\w)/g) || []
    var acronym = matches.join('')
    return acronym
  }

  return ''
}

async function createLabeledLogs(logs, selectedSpecialty) {
  let allLogs = logs
  let specialty = Specialty.getSpecific(selectedSpecialty)

  const componentWOption = Component.query().withAllRecursive().get() || []

  const exludeComponentList = [
    'text-field',
    'text-area',
    'numeric-field',
    'hint-field',
    'hint-field-multiple',
    'image-upload'
  ]
  const exludeIfEmptyComponentList = [
    'single-select',
    'multi-select',
    'date-picker',
    'checkbox',
    'age-field'
  ]

  const autonomyFields = componentWOption.filter(c => c.type === 'autonomy')
  let usersData = []

  if (autonomyFields?.length) {
    let userIds = allLogs.flatMap(l => autonomyFields.map(af => l[af.id]))

    userIds = _.uniq(userIds)

    usersData = await getUsersByIds(userIds)
  }

  allLogs = allLogs.map(log => {
    let labeledLog = { ...log }
    if (log.createdAt) {
      let date = null
      date = moment(log.createdAt).format('DD/MM/YYYY')

      labeledLog.createdAt = {
        id: log.createdAt,
        text: date === 'Invalid Date' ? null : date
      }
    }

    componentWOption.forEach(component => {
      if (
        !exludeComponentList.some(item => item.id === component.type) &&
        component.id !== 'logbook'
      ) {
        if (component.id === 'pathology-diagnosis') {
          labeledLog[component.id] = {
            id: log[component.id]?.id,
            text: log[component.id]?.diagnosis
          }
        } else if (component.type === 'autonomy') {
          const user = usersData.find(ud => ud.id === labeledLog[component.id])

          labeledLog[component.id] = {
            id: log[component.id],
            text: user ? user.name : log[component.id]
          }
        } else if (component.type === 'surgical-autonomy') {
          let autonomyAndUsers = autonomyFields.map(af => ({
            userId: labeledLog[af.id],
            autonomyFieldId: af.id,
            autonomyFieldsText: af.label
          }))

          autonomyAndUsers = autonomyAndUsers.map(au => {
            const user = usersData.find(u => u.id === au.userId)

            return { ...au, userText: user ? user.name : au.userId || '' }
          })

          labeledLog[component.id] = {
            id: log[component.id],
            text: autonomyAndUsers.length
              ? autonomyAndUsers
                  .filter(au => au.autonomyFieldsText && au.userText)
                  .reduce(
                    (acc, au) =>
                      (acc += `${
                        au.autonomyFieldsText !== 'Cirurgião'
                          ? getAcronym(au.autonomyFieldsText)
                          : 'Cir'
                      }: ${getAcronym(au.userText)}; `),
                    ''
                  )
              : ''
          }
        } else if (
          (log[component.id] &&
            exludeIfEmptyComponentList.some(
              item => item.id === component.type
            )) ||
          !exludeIfEmptyComponentList.some(item => item.id === component.type)
        ) {
          let value = specialty.getLabel(log, component)
          if (!value && log[component.id]) {
            value = Array.isArray(log[component.id])
              ? log[component.id].join(', ')
              : log[component.id]
          }
          value
            ? (labeledLog[component.id] = {
                id: log[component.id],
                text: value
              })
            : ''
        }
      } else if (component.id !== 'logbook' && log[component.id]) {
        const str = Array.isArray(log[component.id])
          ? log[component.id].join(', ')
          : log[component.id]
        labeledLog[component.id] = {
          id: log[component.id],
          text: str
        }
      }
    })
    return labeledLog
  })

  return allLogs
}

export default {
  state: {
    logs: [],
    logCount: null,
    labeledLogs: [],
    coordinatorLogs: [],
    labeledCoordinatorLogs: []
  },
  getters: {
    logs: (state, getters) => state.logs,
    labeledLogs: state => state.labeledLogs,
    logCollection: (state, getters) => {
      const logName = getters.selectedSpecialty

      const collections = {
        anesthesiology: 'AnesthesiaLogs',
        pathology: 'PathologyLogs',
        'general-surgery': 'SurgeryLogs',
        orthopedics: 'OrthopedicsLogs',
        oncology: 'OncologyLogs',
        neuroradiology: 'NeuroRadiologyLogs',
        endocrinology: 'EndocrinologyLogs',
        dermatology: 'DermatologyLogs',
        orl: 'OtoRhinoLaryngology'
      }
      return collections[logName] || `${logName}Logs` // TODO: Remove default after demo
    },
    selectedSpecialty(_state, getters) {
      return getters.specialty
    },
    coordinatorLogs: (state, getters) => {
      return state.coordinatorLogs
    },
    labeledCoordinatorLogs: state => state.labeledCoordinatorLogs
  },

  mutations: {
    setlogs(state, logs) {
      state.logs = logs
    },
    setLabeledLogs(state, logs) {
      state.labeledLogs = logs
    },
    setCoordinatorlogs(state, logs) {
      state.coordinatorLogs = logs
    },
    setLabeledCoordinatorLogs(state, logs) {
      state.labeledCoordinatorLogs = logs
    },
    addlog(state, log) {
      state.logs.push(log)
    },
    addLogs(state, logs) {
      state.logs = [...state.logs, ...logs]
    },
    updatelog(state, log) {
      const idx = state.logs.findIndex(s => s.id === log.id)
      state.logs[idx] = log
      state.logs = [...state.logs]
    },

    addLabeledLogs(state, logs) {
      state.labeledLogs = [...state.labeledLogs, ...logs]
    },
    updateLabeledlog(state, log) {
      const idx = state.labeledLogs.findIndex(s => s.id === log.id)
      state.labeledLogs[idx] = log
      state.labeledLogs = [...state.labeledLogs]
    },
    deletelogs(state, logs) {
      for (const { id } of logs) {
        const idx = state.logs.findIndex(s => s.id === id)
        state.logs.splice(idx, 1)
        const lIdx = state.labeledLogs.findIndex(s => s.id === id)
        state.labeledLogs.splice(lIdx, 1)
      }
    },
    setLogCount(state, count) {
      if (!count || Number.isFinite(count)) {
        state.logCount = count
      } else {
        // eslint-disable-next-line no-console
        console.error('Invalid type ', typeof count)
      }
    }
  },
  actions: {
    async addLog({ commit, getters: { specialty } }, fullLog) {
      let labeledLogs = []
      const log = await mongoAddLog(fullLog, specialty)
      commit('addlog', log)

      labeledLogs = await createLabeledLogs([log], specialty)
      commit('addLabeledLogs', labeledLogs)

      return log
    },
    async addLogs({ commit, getters: { specialty } }, logs) {
      let labeledLogs = []
      const insertedLogs = await insertManyClinicalLogs(logs, { specialty })
      commit('addLogs', insertedLogs)
      labeledLogs = await createLabeledLogs(insertedLogs, specialty)
      commit('addLabeledLogs', labeledLogs)
    },
    setLogs({ commit }, logs) {
      commit('setlogs', logs)
    },
    setCoordinatorLogs({ commit }, logs) {
      commit('setCoordinatorlogs', logs)
    },

    async getLabeledLogs({ commit, rootGetters }, selectedSpecialty) {
      let specialty = selectedSpecialty
        ? selectedSpecialty
        : rootGetters.specialty
      const allLogs = await createLabeledLogs([...rootGetters.logs], specialty)
      return commit('setLabeledLogs', allLogs)
    },
    async getLabeledCoordinatorLogs(
      { commit, rootGetters },
      selectedSpecialty
    ) {
      let specialty = selectedSpecialty
        ? selectedSpecialty
        : rootGetters.specialty
      const allLogs = await createLabeledLogs(
        [...rootGetters.coordinatorLogs],
        specialty
      )
      return commit('setLabeledCoordinatorLogs', allLogs)
    },

    async getLogs(
      { commit, getters: { specialty, logs }, rootGetters: { user } },
      { useCache } = { useCache: false }
    ) {
      if (useCache && logs.length > 0) {
        return Promise.resolve()
      }

      const fetched = await getClinicalLogs(user.id, { specialty })
      commit('setlogs', fetched)
    },
    async fetchLogCount({
      commit,
      getters: { selectedSpecialty },
      rootGetters
    }) {
      const count = await getClinicalLogCount(
        selectedSpecialty,
        rootGetters.user.id
      )

      commit('setLogCount', count)
    },
    async getCoordinatorLogs(
      { commit, getters: { selectedSpecialty } },
      userIds
    ) {
      const logs = await getClinicalLogsByUserId(userIds, {
        specialty: selectedSpecialty
      })
      commit('setCoordinatorlogs', logs)
    },
    getSharedLogs({ getters: { selectedSpecialty } }, logIds = []) {
      const query = logIds.map(id => `sharedId=${id}`).join('&')

      return axios
        .get(`/logs?${query}&specialty=${selectedSpecialty}`)
        .then(res => res.data)
    },
    async deleteLogs({ commit, getters: { specialty } }, logs) {
      await removeClinicalLogs(logs, { specialty })
      return commit('deletelogs', logs)
    },
    async updateLog({ commit, getters: { specialty } }, log) {
      let LabeledLog = []
      const updatedLog = await updateClinicalLog(log, { specialty })
      commit('updatelog', updatedLog)
      LabeledLog = await createLabeledLogs([updatedLog], specialty)
      commit('updateLabeledlog', LabeledLog[0])
    }
  }
}

async function mongoAddLog(log, specialty) {
  const insertedLog = await insertClinicalLog(log, {
    specialty
  })
  logEvent('CLINICAL_LOG_SUBMISSION')
  return insertedLog
}
